import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';
import Select from 'react-select';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from '../../../presentational/table-pagination-actions';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TuneIcon from '@material-ui/icons/Tune';
import CloseIcon from '@material-ui/icons/Close';

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment/build/index';
import Api from '../../../../libraries/api';
import Storage from '../../../../libraries/storage';
import AuthHelper from '../../../../libraries/auth-helper';
import CommonHelper from '../../../../libraries/common-helper';
import { history } from '../../../../shared/configure-store';
import { HR_OVERVIEW_ROLES, LEAVE_TYPES, LEAVE_STATUSES } from './constants';

require('dotenv').config();

class UserLeaves extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},

            orderBy: 'start_date',
            sortedBy: 'asc',
            searchBy: '',

            users: [],
            filterUser: null,
            filterStartDate: null,
            filterEndDate: null,
            enableOverview: false,

            showDialog: false,
            idDelete: '',
            currDelete: '',

            rows: [],
            total: 0,
            perPage: 10,
            currentPage: 1,
            currentPageTable: 0,

            permissions: [],

            leaveTypes: LEAVE_TYPES,
            leaveStatuses: LEAVE_STATUSES,
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - User Leaves';
        const permissions = AuthHelper.getProfile()?.permissions || [];
        this.setState({ permissions });
        this.__initProfile();
        this.__fetchData(false);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    __initProfile = () => {
        const profile = AuthHelper.getProfile();
        const enableOverview = HR_OVERVIEW_ROLES.includes(profile?.role);

        this.setState({ enableOverview }, () => {
            if (enableOverview) {
                this.__fetchUsers();
            }
        });
    };

    __fetchUsers = () => {
        Api.get('/users?limit=0&orderBy=name&sortedBy=asc&is_active=1').then(resp => {
            if (resp?.data) {
                const users = resp.data.map((item) => ({
                    value: item.id,
                    label: item.name,
                }));
                this.setState({ users });
            }
        });
    };

    __fetchData = update => {
        this._isMounted = true;

        let page = update ? parseInt(this.state.currentPage + 1) : this.state.currentPage;
        let sort = this.state.orderBy ? '&orderBy=' + this.state.orderBy + '&sortedBy=' + this.state.sortedBy : '';
        let search = this.state.searchBy ? '&search=' + this.state.searchBy : '';
        let filterUser = this.state.filterUser ? '&user_id=' + this.state.filterUser.value : '';
        let filterStart = this.state.filterStartDate
            ? '&start_date=' + moment(this.state.filterStartDate).format('YYYY-MM-DD')
            : '';
        let filterEnd = this.state.filterEndDate
            ? '&end_date=' + moment(this.state.filterEndDate).format('YYYY-MM-DD')
            : '';

        let route = '';

        if (search) {
            route = '/user-leaves?limit=' + this.state.perPage + sort + search + filterUser + filterStart + filterEnd;
        } else {
            route = '/user-leaves?limit=' + this.state.perPage + '&page=' + page + sort + search + filterUser + filterStart + filterEnd;
        }

        Api.get(route).then(resp => {
            if (this._isMounted) {
                if (resp?.data) {
                    this.setState({
                        rows: resp?.data,
                        perPage: resp?.meta?.pagination?.per_page,
                        currentPage: resp?.meta?.pagination?.current_page,
                        currentPageTable: resp?.meta?.pagination?.current_page - 1,
                        total: resp?.meta?.pagination?.total,
                        loading: false,
                        leaveTypes: resp?.meta?.custom?.leaveTypes || LEAVE_TYPES,
                        leaveStatuses: resp?.meta?.custom?.leaveStatuses || LEAVE_STATUSES,
                    });
                } else {
                    this.setState({ loading: false });
                }
            }
        }).catch(() => {
            if (this._isMounted) {
                this.setState({ loading: false });
            }
        });
    };

    handleSearch = () => {
        this.setState({ loading: true }, () => {
            this.__fetchData(false);
        });
    };

    handleResetFilter = () => {
        this.setState({
            searchBy: '',
            filterUser: null,
            filterStartDate: null,
            filterEndDate: null,
            currentPage: 1,
            currentPageTable: 0,
            loading: true,
        }, () => {
            this.__fetchData(false);
        });
    };

    handleKeyDown = (e) => {
        if (e.key === 'Enter') this.handleSearch();
    };

    handleSort = (val) => {
        let sortedBy = this.state.sortedBy;

        if (val !== this.state.orderBy) {
            sortedBy = 'asc';
        } else {
            sortedBy = sortedBy && sortedBy === 'asc' ? 'desc' : 'asc';
        }

        this.setState({
            orderBy: val,
            sortedBy: sortedBy,
            loading: true,
        }, () => {
            this.__fetchData(false);
        });
    };

    handleChange(e, prop) {
        this.setState({ [prop]: e.target.value });
    }

    handleDate = (date, prop) => {
        this.setState({ [prop]: date });
    };

    handleFilterUser = (selected) => {
        this.setState({ filterUser: selected });
    };

    handleOpen = (row) => {
        this.setState({
            showDialog: true,
            idDelete: row.id,
            currDelete: this.__getUserName(row),
        });
    };

    handleClose = () => {
        this.setState({ showDialog: false });
    };

    handleDelete = () => {
        if (!this.state.idDelete) return;

        this.setState({ loadingButton: true });

        const host = process.env.REACT_APP_API_SERVER_URL;
        let access_token = Storage.get('access_token');
        if (access_token) {
            access_token = access_token.replace(/['"]+/g, '');
        }

        fetch(`${host}/user-leaves/${this.state.idDelete}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                ...(access_token ? { Authorization: `Bearer ${access_token}` } : {}),
            },
        })
            .then((resp) => {
                if (!resp.ok) {
                    return Promise.reject();
                }
                this.setState({ showDialog: false, loadingButton: false });
                this.showMessage(true, 'Leave successfully deleted');
                this.__fetchData(false);
            })
            .catch(() => {
                this.setState({ showDialog: false, loadingButton: false });
                this.showMessage(false, 'Failed to delete leave');
            });
    };

    // handleStatusUpdate = (row, status) => {
    //     Api.patch('/user-leaves/' + row.id + '/status', { status }, false).then(() => {
    //         this.showMessage(true, 'Leave status updated');
    //         this.__fetchData(false);
    //     }).catch(() => {
    //         this.showMessage(false, 'Failed to update leave status');
    //     });
    // };

    __getUserName = (row) => {
        return row?.user_name || row?.user?.name || 'NA';
    };

    __getAppliedBy = (row) => {
        return row?.applied_by?.name || 'NA';
    };

    __formatDate = (date) => {
        if (!date) return 'NA';
        const formatted = moment(date).format('DD-MMM-YYYY');
        return formatted === 'Invalid date' ? 'NA' : formatted;
    };

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleChangePage = (event, newPage) => {
        this.setState({
            rows: [],
            currentPage: newPage,
            currentPageTable: newPage,
            loading: true,
        }, () => {
            this.__fetchData(true);
        });
    };

    handleChangeRowsPerPage = event => {
        this.setState({
            perPage: parseInt(event.target.value, 10),
            currentPage: 1,
            loading: true,
        }, () => {
            this.__fetchData(false);
        });
    };

    handleGo = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">User Leaves</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">User Leaves</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <div className="row align-items-center mb-md-3">
                            {/* <div className="col-md-2">
                                <div className="form-group mb-0">
                                    <label>Search</label>
                                    <TextField
                                        variant="outlined"
                                        className="search-field"
                                        onChange={(e) => this.handleChange(e, 'searchBy')}
                                        onKeyDown={this.handleKeyDown}
                                        onBlur={this.handleSearch}
                                        placeholder="Search here"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="start">
                                                    <IconButton
                                                        aria-label="Search click"
                                                        onClick={this.handleSearch}
                                                    >
                                                        <i className="fas fa-search"> </i>
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </div>
                            </div> */}
                            {this.state.enableOverview && (
                                <div className="col-md-3">
                                    <div className="form-group mb-0">
                                        <label>User</label>
                                        <Select
                                            options={this.state.users}
                                            onChange={this.handleFilterUser}
                                            value={this.state.filterUser}
                                            isClearable
                                            isSearchable
                                            styles={{
                                                menu: (baseStyles) => ({ ...baseStyles, zIndex: 3 }),
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                            <div className="col-md-2">
                                <div className="form-group mb-0">
                                    <label>Start Date</label>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            value={this.state.filterStartDate}
                                            onChange={(date) => this.handleDate(date, 'filterStartDate')}
                                            format="DD MMM YYYY"
                                            cancelLabel="BATAL"
                                            inputVariant="outlined"
                                            autoOk
                                            clearable
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group mb-0">
                                    <label>End Date</label>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <DatePicker
                                            value={this.state.filterEndDate}
                                            onChange={(date) => this.handleDate(date, 'filterEndDate')}
                                            format="DD MMM YYYY"
                                            cancelLabel="BATAL"
                                            inputVariant="outlined"
                                            autoOk
                                            clearable
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                            <div className="col-12 col-lg-3 mt-3 mt-lg-4">
                                <div className="row">
                                    <div className="col-6 col-lg-auto mb-2 mb-lg-0 pr-lg-2">
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            className="w-100"
                                            onClick={this.handleSearch}
                                        >
                                            <TuneIcon />
                                            &nbsp; Filter
                                        </Button>
                                    </div>
                                    <div className="col-6 col-lg-auto mb-2 mb-lg-0">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            className="w-100"
                                            onClick={this.handleResetFilter}
                                        >
                                            <CloseIcon />
                                        </Button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-lg-2 mt-3 mt-lg-4">
                                <div className="row">
                                    {CommonHelper.checkPermission(this.state.permissions, 'create-user-leaves') && (
                                        <div className="col-12 col-lg-auto ml-lg-auto">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className="w-100"
                                                onClick={() => this.handleGo('/user-leaves/add')}
                                            >
                                                <i className="fas fa-plus"> </i>
                                                &nbsp; Apply Leave
                                            </Button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>

                        <Table className="table-list" size="small">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="clickable" onClick={() => this.handleSort('user_name')}>
                                        Name
                                        {this.state.orderBy === 'user_name' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('leave_type')}>
                                        Leave Type
                                        {this.state.orderBy === 'leave_type' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('start_date')}>
                                        Start Date
                                        {this.state.orderBy === 'start_date' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('end_date')}>
                                        End Date
                                        {this.state.orderBy === 'end_date' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('status')}>
                                        Status
                                        {this.state.orderBy === 'status' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell className="clickable" onClick={() => this.handleSort('applied_by')}>
                                        Applied By
                                        {this.state.orderBy === 'applied_by' && (
                                            <span className="icon-sort">{
                                                this.state.sortedBy === 'asc' ? (
                                                    <i className="fas fa-sort-up"> </i>
                                                ) : (
                                                    <i className="fas fa-sort-down"> </i>
                                                )
                                            }</span>
                                        )}
                                    </TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.state.loading ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center" className="py-5">
                                            <CircularProgress color="primary" />
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    this.state.rows.length === 0 ? (
                                        <TableRow style={{ height: 33 * this.state.perPage }}>
                                            <TableCell colSpan={7} style={{ textAlign: 'center' }}>No leave data</TableCell>
                                        </TableRow>
                                    ) : (
                                        this.state.rows.map(row => (
                                            <TableRow key={row.id} selected={row.selected}>
                                                <TableCell>{this.__getUserName(row)}</TableCell>
                                                <TableCell>{row.leave_type || 'NA'}</TableCell>
                                                <TableCell>{this.__formatDate(row.start_date)}</TableCell>
                                                <TableCell>{this.__formatDate(row.end_date)}</TableCell>
                                                <TableCell>{row.status || 'NA'}</TableCell>
                                                <TableCell>{this.__getAppliedBy(row)}</TableCell>
                                                <TableCell>
                                                    <div className="d-flex">
                                                        {CommonHelper.checkPermission(this.state.permissions, 'update-user-leaves') && (
                                                            <Link to={'/user-leaves/edit/' + row.id} className="btn-icon mr-2">
                                                                <i className="fas fa-edit"> </i>
                                                            </Link>
                                                        )}
                                                        {/* {this.state.isUpdate && row.status === 'Pending' && (
                                                            <>
                                                                <button
                                                                    className="btn-icon mr-2"
                                                                    title="Approve"
                                                                    onClick={() => this.handleStatusUpdate(row, 'Approved')}
                                                                >
                                                                    <i className="fas fa-check text-success"> </i>
                                                                </button>
                                                                <button
                                                                    className="btn-icon mr-2"
                                                                    title="Reject"
                                                                    onClick={() => this.handleStatusUpdate(row, 'Rejected')}
                                                                >
                                                                    <i className="fas fa-times text-danger"> </i>
                                                                </button>
                                                            </>
                                                        )} */}
                                                        {CommonHelper.checkPermission(this.state.permissions, 'delete-user-leaves') && (
                                                            <button className="btn-icon" onClick={() => this.handleOpen(row)}>
                                                                <i className="fas fa-trash-alt"> </i>
                                                            </button>
                                                        )}
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                    )
                                )}
                            </TableBody>
                        </Table>
                    </div>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 50]}
                        component="div"
                        count={this.state.total}
                        rowsPerPage={this.state.perPage}
                        page={this.state.currentPageTable}
                        backIconButtonProps={{
                            'aria-label': 'previous page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'next page',
                        }}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        ActionsComponent={TablePaginationActions}
                    />
                </div>

                <Dialog
                    maxWidth="sm"
                    fullWidth={true}
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">DELETE DATA: {this.state.currDelete}</DialogTitle>
                    <DialogContent>
                        <p>Are you sure you want to delete this leave request?</p>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            variant="contained"
                            className="mr-3"
                            onClick={this.handleClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleDelete}
                            disabled={this.state.loadingButton && 'disabled'}
                        >
                            Delete{this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i>}
                        </Button>
                    </DialogActions>
                </Dialog>

                <ToastContainer autoClose={3000} />
            </div>
        );
    }
}

export default UserLeaves;
